import styled, { css } from 'styled-components';
import { resolveColor } from 'ui/styles/utils/colors';

export const NavLink = styled.a<{ $active?: boolean; $wide?: boolean; $disabled?: boolean }>`
  display: block;
  ${({ $wide }) =>
    css`
      padding: ${$wide ? '0rem 0 0rem 32px' : '0rem 24px'};
    `};
  line-height: 34px;
  font-size: 14px;
  font-weight: 700;
  line-height: 140%;
  margin-bottom: 16px;
  color: ${({ theme, $disabled }) => resolveColor(theme, $disabled ? 'grayMain' : 'white')};
  cursor: ${({ $disabled }) => ($disabled ? 'default' : 'pointer')}
    ${({ $active, $disabled, theme }) =>
      $active &&
      css`
        position: relative;
        color: ${resolveColor(theme, $disabled ? 'grayMain' : 'marker')};
        &:before {
          left: 0;
          top: 0;
          bottom: 0;
          position: absolute;
          content: '';
          border: 3px solid ${resolveColor(theme, $disabled ? 'grayMain' : 'marker')};
        }
      `};

  &:hover {
    color: ${({ theme, $disabled }) => resolveColor(theme, $disabled ? 'grayMain' : 'marker')};
    text-decoration: none;
  }
`;

export const SidebarNavGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  margin-bottom: 0;
  padding-left: 0;
  width: 100%;
  flex-direction: column;
  color: white;
`;
